const Hidden = (/* props */) => null;

export default Hidden;
